export const BLOCKED_EMAIL_DOMAINS: string[] = [
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'yahoo.co.in',
  'yahoo.in',
  'yahoo.co.uk',
  'yahoo.ca',
  'yahoo.com.au',
  'hotmail.com',
  'hotmail.co.uk',
  'hotmail.co.in',
  'outlook.com',
  'outlook.in',
  'live.com',
  'msn.com',
  'aol.com',
  'rediffmail.com',
  'ymail.com',
  'rocketmail.com',
  'mail.com',
  'zoho.com',
  'zohomail.com',
  'gmx.com',
  'gmx.de',
  'gmx.net',
  'gmx.co.uk',
  'protonmail.com',
  'proton.me',
  'pm.me',
  'facebook.com',
  'facebookmail.com',
  'gamil.com',
  'gmanil.com',
  'gmil.com',
  'gemail.com',
  'gammal.com',
  'gimel.com',
  'gnail.com',
  'gmial.com',
  'hotnail.com',
  '10minutemail.com',
  '20minutemail.com',
  '30minutesmail.com',
  '0-mail.com',
  'your-mail.com',
  'spryiq.co',
];

// Mirrors the route-path -> product-name mapping shared by navbar.ts, footer-banner.ts,
// and email-cta.ts to resolve which product a visitor is currently on.
export const PRODUCTS_BY_PATH: Record<string, string> = {
  'itsm-tool': 'Infraon ITSM',
  'it-asset-management': 'Infraon ITAM',
  'it-ops-management': 'Infraon Infinity',
  'ai-ops-tool': 'Infraon AIOps',
  nccm: 'Infraon NCCM',
  'itim-ims': 'Infraon ITIM/IMS',
  'infraon-oss': 'Infraon OSS',
};
